import type { InnogyComponentRendering } from '@core/jss-models';
import { getDroplinkValue, getFieldValue } from '@core/jss-utils';
import type {
  ColumnConfig,
  ColumnOrder,
  ColumnWidth,
  DynamicRowSettings,
} from '@legacy/common-ui-shared-interfaces';
import type { ContentContext } from '@legacy/common-ui-partials';

export function getDynamicRowSettingsFromRendering(
  rendering: InnogyComponentRendering
): DynamicRowSettings {
  const variant = getDroplinkValue(rendering.fields, 'Variant') || '12';
  const orderMobile =
    getDroplinkValue(rendering.fields, 'ColumnOrderMobile') || '1-2-3-4-5-6';
  const columnConfigs = getColumnConfigsFromRendering(
    variant,
    orderMobile,
    rendering
  );
  return {
    variant,
    paddingContainer:
      getDroplinkValue(rendering.fields, 'PaddingContainer') || '',
    paddingRow: getDroplinkValue(rendering.fields, 'PaddingRow') || '',
    columnJustification:
      getDroplinkValue(rendering.fields, 'ColumnJustification') || '',
    columnConfigs,
    anchorPoint: getFieldValue(rendering.fields, 'AnchorPoint', null),
    context:
      (getDroplinkValue(rendering.fields, 'Context') as ContentContext) ??
      'default',
  };
}

function getColumnConfigsFromRendering(
  variant: string,
  orderMobile: string,
  rendering: InnogyComponentRendering
): ColumnConfig[] {
  if (!!variant) {
    const columnWidths = variant.split('-');
    const positions = orderMobile.split('-');
    return columnWidths.map((width, index) => ({
      padding:
        getDroplinkValue(rendering.fields, `PaddingColumn${index + 1}`) || '',
      width: parseInt(width, 10) as ColumnWidth,
      hideOnMobile: getFieldValue(
        rendering,
        `HideOnMobileColumn${index + 1}`,
        false
      ),
      orderMobile: parseInt(positions[index]) as ColumnOrder,
    }));
  }
  return [];
}
